export default "__VITE_ASSET__CGKiW8Qa__"